<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <span class="footerDetail">
      © {{ new Date().getFullYear() }}
      <a href="https://triple-a.io" target="_blank" rel="noopener"
        >{{ legalEntity }}.</a
      >
      - All Rights Reserved
      <small>(v{{ version }})</small>
    </span>
    <span class="md:flex hidden items-center">
      <span>Cryptocurrency payment gateway</span>
    </span>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String,
    },
  },
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
    };
  },
  computed: {
    ...mapGetters(['activeMerchantGetter']),
    legalEntity() {
      return (
        this.activeMerchantGetter &&
        this.activeMerchantGetter.triplea_legal_entity
      );
    },
  }
};
</script>

<style scoped>
@media only screen and (min-width: 1200px) {
  .footerDetail {
    padding-left: 260px;
  }
}
</style>
